module.exports = __webpack_public_path__ + "static/media/defaultAvatar6.7f07039d.svg";